$(document).ready(function () {
    $(".readMore").click(function () {
        $(this).prev().toggleClass("hidden");
        if ($(this).prev().hasClass("hidden")) {
            if ($(".readMore").hasClass("BG__version")) {
                $(this).text("Виж повече");
            } else {
                $(this).text("Read More");
            }
        } else {
            if ($(".readMore").hasClass("BG__version")) {
                $(this).text("Виж по-малко");
            } else {
                $(this).text("View Less");
            }
        }
    });
    if ($('.info__module .info__grid .info__item .description__content').find('a')) {
        let foundLinks = $('.info__module .info__grid .info__item .description__content').find('a');
        $.each($(foundLinks), function (index, elem) {
            if (!($(elem).hasClass('btn'))) {
                $(elem).append('<i class="fas fa-arrow-right info-array-link-decoration"></i>');
            }
        });
    }

    // Get the fragment identifier (the # symbol followed by the ID of the target <div>) from the URL
    var hash = window.location.hash;
    
    if (hash) {
        var target = $(hash);
        $('html, body').animate({
          scrollTop: target.offset().top - 50
        }, 1000);
    }
});